<span>{{ message | translate }}</span>